var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticStyle: { width: "100%" } }, [
    _c(
      "div",
      { staticClass: "panel-group" },
      _vm._l(_vm.quickInsightsCategories, function(category, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "panel panel-default quick-insight-category"
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "panel-heading quick-insight-category__name clickable",
                on: {
                  click: function($event) {
                    return _vm.toggleAccordion(index)
                  }
                }
              },
              [
                _c("i", { staticClass: "f-s-16", class: category.icon }),
                _vm._v("\n        " + _vm._s(category.name) + "\n      ")
              ]
            ),
            _vm._v(" "),
            _c(
              "collapse",
              {
                model: {
                  value: _vm.showAccordion[index],
                  callback: function($$v) {
                    _vm.$set(_vm.showAccordion, index, $$v)
                  },
                  expression: "showAccordion[index]"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "panel-body p-0" },
                  _vm._l(category.questions, function(question, questionIndex) {
                    return _c(
                      "div",
                      {
                        key: questionIndex,
                        staticClass:
                          "quick-insight-category__question clickable",
                        on: {
                          click: function($event) {
                            return _vm.goToRoute(question.route)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(question.question) +
                            "\n          "
                        )
                      ]
                    )
                  }),
                  0
                )
              ]
            )
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }